/**
 * Labstep
 *
 * @module core/DatePreview
 * @desc A component showing a date
 */

import { TextSmall } from 'labstep-web/core/Text/Small';
import {
  dateOnly,
  humanReadableDate,
  timeOnly,
} from 'labstep-web/services/date.service';
import type React from 'react';
import type { IDatePreviewProps } from './types';

export const DateSmall: React.FC<IDatePreviewProps> = ({
  dateString,
}) => <TextSmall>{humanReadableDate(dateString)}</TextSmall>;

export const DatePreview: React.FC<IDatePreviewProps> = ({
  dateString,
}) => (
  <div>
    <span>{dateOnly(dateString)}</span> <span>at</span>{' '}
    <span>{timeOnly(dateString)}</span>
  </div>
);
